module.exports = __webpack_public_path__ + "a8b2e58cd3a9840eab9a89e300f2eaf0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/annotated-example-1.png
// module id = 1681
// module chunks = 0